import apiGroups from '../../api/apiGroups'

const state = {
    isLoading: false,
    groups: [],
    settings: '',
    selectedGroup: {},
    recommendedGroup: {},
    newGroup: {
        id: null,
        name: null,
        remarks: null,
        max_wins: 1,
        date: null
    }
}

const getters = {
    getNewGroup: (state) => {
        return state.newGroup
    },
    getGroupNames: (state) => {
        return state.groupNames
    },
    getGroups: (state) => {
        return state.groups
    },
    getGroupSettings: (state) => {
        return state.settings
    },
    getSelectedGroup: (state) => {
        return state.selectedGroup
    },
    getGroupLoadingStatus: (state) => {
        return state.isLoading
    },
    getRecommendedGroup: (state) => {
        return state.recommendedGroup
    }
}

const mutations = {
    setGroups: (state, newGroups) => {
        state.groups = newGroups
    },
    setNewGroup: (state, newGroup) => {
        state.newGroup = newGroup
    },
    setGroupSettings: (state, newSettings) => {
        state.settings = newSettings
    },
    setSelectedGroup: (state, newValue) => {
        state.selectedGroup = newValue
    },
    setSelectedGroupFieldValue: (state, groupInput) => {
        state.selectedGroup[groupInput.field] = groupInput.value
    },
    setGroupsLoadingStatus: (state, newValue) => {
        state.isLoading = newValue
    },
    setNewGroupFieldValue: (state, groupInput) => {
        state.newGroup[groupInput.field] = groupInput.value
    },
    addGroupToGroups: (state, newGroup) => {
        state.groups.push(newGroup)
    },
    setRecommendedGroup: (state, newValue) => {
        state.recommendedGroup = newValue
    }
}

const actions = {
    changeGroupsLoadingStatus: ({ commit }, newValue) => {
        commit('setGroupsLoadingStatus', newValue)
    },
    changeSelectedGroupFieldValue: ({ commit }, newValue) => {
        commit('setSelectedGroupFieldValue', newValue)
    },
    changeSelectedGroup: ({ commit }, newValue) => {
        commit('setSelectedGroup', newValue)
    },
    changeNewGroupFieldValue: ({ commit }, newValue) => {
        commit('setNewGroupFieldValue', newValue)
    },
    fetchGroups: ({ commit, state, dispatch }, query) => {
        commit('setGroupsLoadingStatus', true)
        dispatch('changeResultBiddingModalLoadingStatus', true)
        apiGroups
            .userBidGroupsRequest(query)
            .then((response) => {
                commit('setGroups', response.data.groups)
                commit('setNewGroupFieldValue', {field: 'id', value: null })
                commit('setNewGroupFieldValue', {field: 'name', value: response.data.name })
                commit('setNewGroupFieldValue', {field: 'remarks', value: null })
                commit('setNewGroupFieldValue', {field: 'max_wins', value: 1 })
                commit('setNewGroupFieldValue', {field: 'date', value: response.data.date })
                commit('setRecommendedGroup', response.data.selectedGroup)
                if (response.data.selectedGroup !== null) {
                    commit('setSelectedGroup', response.data.selectedGroup)
                } else {
                    commit('setSelectedGroup', { id: null, name: response.data.name, remarks: null, max_wins: 1, date: response.data.date })
                }
                if (!response.data.groups.length > 0) {
                    commit('setSelectedGroup', state.newGroup)
                }
                commit('setGroupsLoadingStatus', false)
                dispatch('changeResultBiddingModalLoadingStatus', false)
            })
    },
    fetchGroupSettings: ({ commit }) => {
        apiGroups
            .userGroupSettingsRequest()
            .then((response) => {
                commit('setGroupSettings', response.data)

            })
    },
    updateSelectedGroup:({ commit, getters, dispatch }) => {
        dispatch('changeBidError', {field: 'status', value: false})
        dispatch('changeBidError', {field: 'message', value:''})
        commit('setGroupsLoadingStatus', true)
        apiGroups
            .userGroupUpdateRequest(getters.getSelectedGroup)
            .then((response) => {
                commit('setGroupsLoadingStatus', false)
            })
            .catch((err) => {
                console.log(err.response)
                commit('setGroupsLoadingStatus', false)
                dispatch('changeBidError', {field: 'status', value: true})
                dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
            })
    },
    createNewGroup: ({ commit, getters, dispatch }) => {
        dispatch('changeBidError', {field: 'status', value: false})
        dispatch('changeBidError', {field: 'message', value:''})
        commit('setGroupsLoadingStatus', true)
        apiGroups
            .createGroupRequest(getters.getNewGroup)
            .then((response) => {
                commit('setGroupsLoadingStatus', false)
                commit('setNewGroup', {id: null, name: null, remarks: null, max_wins: 1, date: getters.getNewGroup.date})
                commit('addGroupToGroups', response.data)
            })
            .catch((err) => {
                console.log(err.response)
                commit('setGroupsLoadingStatus', false)
                dispatch('changeBidError', {field: 'status', value: true})
                dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
            })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/groups.js